export const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true

export const motionDuration = (duration) => prefersReducedMotion() ? 0 : duration

export const shouldShowOpening = () => {
  if (prefersReducedMotion()) return false
  try { return sessionStorage.getItem('pokewudi:opening:v1') !== 'seen' } catch { return true }
}

export const rememberOpening = () => {
  try { sessionStorage.setItem('pokewudi:opening:v1', 'seen') } catch { /* Storage may be disabled. */ }
}
